import {required} from "vuelidate/lib/validators";  
import moment from 'moment' 
const satdosya = {
    data() { 
      return {   
        satdosyaData: { 
          dosyaadi: "", 
          dosyaacilistarih: "", 
          alimturu: [], 
          alimnedeni: "", 
          cerceveanlasma: false, 
          ihaleturu: [], 
          kanunaciklamasi: "", 
          sozlesmeturu: null, 
          teklifdegerlendirmeyontem: null, 
          dosyasifre: "", 
          dosyamenu:"",
          ihaleyiyapanmakam:null,
          tamamlandi: false, 
          strperfdonem: null,
          amacid: null,
          hedefiid: null,
          yaklasikmaliyetwebsite: false, 
          yaklasikmaliyetwebsitesontarih:null,
          Yaklasikmaliyetwebsiteilktarih: null,
          ihalesonucuwebsite: false, 
          faaliyetid:null,
          hesapkodu: null,
          hesapkodu2: null,
          butcedisi: false,
          gerceklestirmegorevlisiid: null,
          harcamagorevlisiid: null,
          dosyamalzemebelge: null,
          ekapno: null,
          yaklasikmaaliyetbirimfiyat: false

          }, 

          Sozlesmeturu: [
            {Id:"1",Value:"Götürü bedel sözleşme (MAL, HİZMET)"},
            {Id:"2",Value:"Birim fiyat sözleşme (MAL, HİZMET, YAPIM)"},
            {Id:"3",Value:"Çerçeve anlaşmaya dayalı münferit sözleşme (MAL, HİZMET, YAPIM)"},
            {Id:"4",Value:"Anahtar teslimi götürü bedel sözleşme (YAPIM)"},
            {Id:"5",Value:"Karma sözleşme (YAPIM)"},
            {Id:"6",Value:"Sözleşme Yok"}
          ], 

          Teklifdegerlendirmeyontem: [
            {Id:"1",Value:"Götürü bedel"},
            {Id:"2",Value:"Birim fiyat"}
          ], 
          FormDataType:{
            Dosyaadi:{FieldName:"dosyaadi",Field:"input",FieldTitle:this.$t('satdosya.AddEdit.dosyaadi')},  
            Dosyaacilistarih:{FieldName:"dosyaacilistarih",Field:"input",FieldTitle: this.$t('satdosya.AddEdit.dosyaacilistarih'),FieldType:"date"},
            Alimturu:{FieldName:"alimturu",Field:"combobox",FieldTitle:this.$t('satdosya.AddEdit.alimturu'),ComboDataArray:[]},
            Alimnedeni:{FieldName:"alimnedeni",Field:"textarea",FieldTitle:this.$t('satdosya.AddEdit.alimnedeni')},  
            Cerceveanlasma:{FieldName:"cerceveanlasma",Field:"checkbox",FieldTitle:this.$t('satdosya.AddEdit.cerceveanlasma')},
            Ihaleturu:{FieldName:"ihaleturu",Field:"combobox",FieldTitle:this.$t('satdosya.AddEdit.ihaleturu'),ComboDataArray:[]},
            Kanunaciklamasi:{FieldName:"kanunaciklamasi",Field:"textarea",FieldTitle:this.$t('satdosya.AddEdit.kanunaciklamasi')}, 
            Sozlesmeturu:{FieldName:"sozlesmeturu",Field:"combobox",FieldTitle:this.$t('satdosya.AddEdit.sozlesmeturu'),ComboDataArray:[]},
            Teklifdegerlendirmeyontem:{FieldName:"teklifdegerlendirmeyontem",Field:"combobox",FieldTitle:this.$t('satdosya.AddEdit.teklifdegerlendirmeyontem'),ComboDataArray:[]},
            Dosyasifre:{FieldName:"dosyasifre",Field:"input",FieldTitle:this.$t('satdosya.AddEdit.dosyasifre')},
            Ihaleyiyapanmakam:{FieldName:"ihaleyiyapanmakam",Field:"combobox",FieldTitle:this.$t('satdosya.AddEdit.ihaleyiyapanmakam'),ComboDataArray:[]},
            Tamamlandi:{FieldName:"tamamlandi",Field:"checkbox",FieldTitle:this.$t('satdosya.AddEdit.tamamlandi')},
            strperfdonem:{FieldName:"Strperfdonem",Field:"combobox",FieldTitle:this.$t('satdosya.AddEdit.strdonemid'),ComboDataArray:[]}, 
            amacid:{FieldName:"amacid",Field:"combobox",FieldTitle:this.$t('satdosya.AddEdit.amacid'),ComboDataArray:[]}, 
            hedefiid:{FieldName:"hedefiid",Field:"combobox",FieldTitle:this.$t('satdosya.AddEdit.hedefiid'),ComboDataArray:[]}, 
            Yaklasikmaliyetwebsite:{FieldName:"Yaklasikmaliyetwebsite",Field:"checkbox",FieldTitle:this.$t('satdosya.AddEdit.yaklasikmaliyetwebsite')},
            Yaklasikmaliyetwebsitesontarih:{FieldName:"Yaklasikmaliyetwebsitesontarih",Field:"input",FieldTitle:this.$t('satdosya.AddEdit.yaklasikmaliyetwebsitesontarih')},
            Yaklasikmaliyetwebsiteilktarih:{FieldName:"Yaklasikmaliyetwebsiteilktarih",Field:"input",FieldTitle:this.$t('satdosya.AddEdit.yaklasikmaliyetwebsiteilktarih')},
            Ihalesonucuwebsite:{FieldName:"Ihalesonucuwebsite",Field:"checkbox",FieldTitle:this.$t('satdosya.AddEdit.ihalesonucuwebsite')},
            faaliyetid:{FieldName:"faaliyetid",Field:"combobox",FieldTitle:this.$t('satdosya.AddEdit.faaliyetid'),ComboDataArray:[]}, 
            hesapkodu:{FieldName:"hesapkodu",Field:"combobox",FieldTitle:this.$t('satdosya.AddEdit.hesapkodu'),ComboDataArray:[]},
            hesapkodu2:{FieldName:"hesapkodu2",Field:"combobox",FieldTitle:this.$t('satdosya.AddEdit.hesapkodu'),ComboDataArray:[]},  
            Butcedisi:{FieldName:"butcedisi",Field:"checkbox",FieldTitle:this.$t('satdosya.AddEdit.Butcedisi')},
            harcamagorevlisiid:{FieldName:"harcamagorevlisiid",Field:"input",FieldTitle:this.$t('satdosya.AddEdit.harcamagorevlisiid'),ComboDataArray:[]}, 
            gerceklestirmegorevlisiid:{FieldName:"gerceklestirmegorevlisiid",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Gerceklestimeid'),ComboDataArray:[]}, 
            dosyamalzemebelge:{FieldName:"dosyamalzemebelge",Field:"input"}, 
            ekapno:{FieldName:"ekapno",Field:"input",FieldTitle:this.$t('satdosya.AddEdit.ekapno')},
            yaklasikmaaliyetbirimfiyat:{FieldName:"yaklasikmaaliyetbirimfiyat",Field:"checkbox",FieldTitle:this.$t('satdosya.AddEdit.yaklasikmaaliyetbirimfiyat')},
          } ,
            Dosyaacilistarih: moment(new Date()).format('YYYY-MM-DD')
      }
    },  
    validations:{ 
      FormData: {  
        dosyaadi:{required},  
        dosyaacilistarih:{required}, 
        alimturu:{required},
        alimnedeni:{},
        cerceveanlasma:{required},
        ihaleturu:{required},
        sozlesmeturu:{},
        teklifdegerlendirmeyontem:{},   
        kanunaciklamasi:{},  
        dosyasifre:{},
        tamamlandi:{},  
        ihaleyiyapanmakam:{},
        strperfdonem: {},
        amacid: {},
        hedefiid: {},
        yaklasikmaliyetwebsite: {},
        yaklasikmaliyetwebsitesontarih: {},
        Yaklasikmaliyetwebsiteilktarih: {},
        ihalesonucuwebsite: {},
        faaliyetid: {},
        hesapkodu: {},
        hesapkodu2: {},
        butcedisi: {},
        harcamagorevlisiid: {},
        gerceklestirmegorevlisiid: {},
        dosyamalzemebelge: {},
        ekapno: {},
        yaklasikmaaliyetbirimfiyat: {}

      }
 
  },
  created(){

    let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }

          this.ActionsSabitGet(1548).then(res => {  
            for(var i=0; i<res.Data.length; i++)
              {
                this.FormDataType.Alimturu.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
              }    
          }); 

          this.ActionsSabitGet(1552).then(res => {  
            for(var i=0; i<res.Data.length; i++)
              {
                this.FormDataType.Ihaleturu.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
              }    
          }); 

          for( var i=0; i<this.Sozlesmeturu.length; i++)
          {
              this.FormDataType.Sozlesmeturu.ComboDataArray.push ({Id:this.Sozlesmeturu[i].Id,Value:this.Sozlesmeturu[i].Value})
          }


          for( i=0; i<this.Teklifdegerlendirmeyontem.length; i++)
          {
              this.FormDataType.Teklifdegerlendirmeyontem.ComboDataArray.push ({Id:this.Teklifdegerlendirmeyontem[i].Id,Value:this.Teklifdegerlendirmeyontem[i].Value})
          }

          this.ActionsGet({ Service: "OBirim", Page: Page }).then((res) => {
            for (var i = 0; i < res.Data.length; i++) {
              this.FormDataType.Ihaleyiyapanmakam.ComboDataArray.push({
                Id: res.Data[i].Id,
                Value: res.Data[i].BirimAdi,
              });
            }
          });
          this.ActionsGet({ "Service": "OBirim/GetTreeByAnaBirim", "Page": Page }).then((res) => {
            this.FormDataType.Ihaleyiyapanmakam.ComboDataArray .push({ id: 1, label: "Tümü", children: null });
            this.FormDataType.Ihaleyiyapanmakam.ComboDataArray[0].children = JSON.parse(JSON.stringify(res.Data).replaceAll('"children":null,', ''));
            
          });


          let sorgu = "&Tip=1561";
          let Tip=[];
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==1 || res.Data[i].Kod==2 ) { 
                        Tip.push(res.Data[i].Id);       
                    } 
                }
                let altsorgu="&UstIdDoluMu=false&Approval=true";
                let tipler="";
                for (var s=0; s<Tip.length; s++){
                    tipler=tipler+"&TipId="+Tip[s];
                }
                altsorgu=altsorgu+tipler;
                this.ActionsFilterGet({"Service":"StrPerfDonem","Page":Page,Filter:altsorgu}).then(res => {  
                  for(var i=0; i<res.Data.length; i++)
                    {
                      if(this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= this.Dosyaacilistarih && this.Dosyaacilistarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)){
                        if(!res.Data[i].UstId ){
                          if(res.Data[i].Id != '53b044e8-44ab-4671-bae0-f7896a0b4974'){
                            this.FormDataType.strperfdonem.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama}); 
                          }
                     
                    } 
                  } 
                    }    
                }); 
            });
           

  }
}
export default satdosya